import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseComponent } from '../../../common/base.component';
import { FilterTitleComponent } from '../../../common/filter-title/filter-title.component';
import { Filter, JewelleryFilter } from '../../../models/filter-models';
import { FilterService } from '../../../services/filter.service';
import { ActiveSpecialRules } from '../../../services/filter-generator.service';
import { JewelleryFilterComponent } from './jewellery-filter/jewellery-filter.component';
import { confirmRemove } from '../../../common/confirm-remove';

@Component({
  selector: 'app-my-jewellery-list',
  imports: [FormsModule, FilterTitleComponent, JewelleryFilterComponent],
  templateUrl: './my-jewellery-list.html',
  styleUrl: './my-jewellery-list.scss'
})
export class MyJewelleryListComponent extends BaseComponent {
  @Input({ required: true }) filter!: Filter;
  @Input({ required: true }) activeSpecialRules!: ActiveSpecialRules;

  constructor(private filterService: FilterService) {
    super();
  }

  removeJewelleryType(index: number) {
    if (!confirmRemove('Are you sure you want to remove this Jewellery Type?')) return;
    this.filter.jewelleryFilters.splice(index, 1);
    this.updateFilter();
  }

  addJewelleryType = () => { this.filter.jewelleryFilters.push(new JewelleryFilter()); this.updateFilter(); }

  updateFilter() {
    this.filterService.updateFilter();
  }
}
